import React from "react";
import { useSelector } from "react-redux";

function DeviceDetails() {
  const editField = useSelector((state) => state.shipment.ui.editShipment.editField);
  const shipmetProfile = useSelector((state) => state?.shipment?.data?.shipProfile);
  const selectedProfileId = useSelector((state) => state.shipment.ui.editShipment.selectedProfileId); 
  const deviceName = useSelector((state) => state?.shipment?.data?.deviceName);

  function getShipmentByid(profileid, key) {
    const item = shipmetProfile?.find(obj => obj.profileid === profileid);
    return item ? item[key] : null;
  }
  function getValueByDeviceAndKey(diviceid, key) {
    const item = deviceName?.devices?.find(obj => obj?.uid === diviceid);
    return item ? item[key] : null;
  }
  return (
    <>
      <div
        className="font-face-vzw py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171",
        }}
      >
        Device details
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Device Model
          </span>
          <div>{editField?.devicetype?.value}</div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Device Name
          </span>
         <div
            style={{
              wordBreak: "break-all",
              overflowWrap: "break-word",
              maxWidth: "96%"
            }}
          >{getValueByDeviceAndKey(editField?.deviceId?.value, "name") }</div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Device Profile
          </span>
            <div
              style={{
                wordBreak: "break-all",
                overflowWrap: "break-word",
                maxWidth: "100%"
              }}
            >{getShipmentByid(selectedProfileId, "profilename") }</div>
          {/* <div>{editField?.selectProfile?.value?.name}</div> */}
        </div>
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-33 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Enable BLE Devices
          </span>
          <div>{editField?.isBLEEnabled?.value==="no" ? "No" : "Yes"}</div>
        </div>
        <div className="d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            On shipment completion
          </span>
          <div>{editField?.onShipmentCompletion?.value==="Keep this device profile"?  "Keep this device profile": getShipmentByid(editField?.onShipmentCompletion?.value , "profilename") }</div>
        </div>
      </div>
    </>
  );
}

export default DeviceDetails;
